import React from 'react'
import './ErrorLayout.css'
import { exclamation_icon } from '../../Shared/icons'

function ErrorLayout(props) {
    return (
        <>
            <div className='error-container d-flex justify-content-center'>
                <div style={{ width: '800px' }}>
                    <div>
                        <div className="icon-box">
                            <div className={'error-container-icon'}>{exclamation_icon}</div>
                        </div>
                        <h4 className="header-text w-100">{props.title}</h4>
                        {props.subTitle != null && <h5 className="text-center text-secondary">{props.subTitle}</h5>}
                    </div>
                    {props.messages != null &&
                        <div className="error-container-body">
                            <ul className="list-group">
                                {props.messages.map((error, index) => <li key={index} className="list-group-item" style={{ fontSize: '16px' }}>{error}</li>)}
                            </ul>
                        </div>
                    }
                    {props.onClick != null &&
                        <div className="error-container-footer mt-5">
                            <button className="btn w-50" onClick={props.onClick}>{props.buttonText}</button>
                        </div>
                    }
                </div>
            </div>
        </>
    )
}


export default ErrorLayout